"use strict";

(function () {
    /*
     To enable mock API response, add configuration code here
     Arguments:
         matchPattern [string | RegExp] (required):
             The url pattern of API request whose response to be mocked
         type [string] (required):
             The http request type (e.g. get, post, put, etc) of the target url
         mockFileName [string] (optional):
             The name of the json file storing the mocked response data (the file should be under /app/mocks/ directory).
             If not provided and updateProperties is provided, updateProperties will be set upon real API responses.
         updateProperties [object] (optional):
             The certain properties to customize upon the mock response or real API responses.
     Examples:
       window.mogo.registry.mogoUI.config.mockServiceConfigs = [
         {matchPattern: '/loans', type: 'get', mockFileName: 'money-inprogress.json', updateProperties: {fs_loans: {bank_account: {bank_verification_status: 'required'}, loan_application_status: 'complete'}}}
       ];
    */

    window.mogo.registry.mogoUI.config.mockServiceConfigs = [];
})();